import { useQuery } from '@tanstack/react-query';
import { screeningTestsApi } from '../../../apis';
import reFetchingHelper from '../../../common/reFetchingHelper';

const IN_FLIGHT_STATUSES = ['NEW', 'SCHEDULED', 'RUNNING'];

export const useQueryScreeningFlowDraftTestRuns = (draftId: number) =>
  useQuery({
    queryKey: ['screeningFlowDraftTestRuns', draftId],
    queryFn: () => screeningTestsApi.findScreeningTestsForDraft({ draftId }),
    enabled: !Number.isNaN(draftId),
    refetchInterval: (query) => {
      const runs = query.state.data;
      if (!runs?.some((run) => IN_FLIGHT_STATUSES.includes(run.status))) {
        return false;
      }
      return reFetchingHelper.getScreeningFlowDraftTestRunsReFetchInterval();
    },
  });
